import { connect } from 'react-redux';
import Documents from '../components/documents';
import { fetchDocuments } from './documents-actions';

const mapStateToProps = state => ({
  documents: state.documents.documents,
  isLoading: state.documents.isLoading,
  error: state.documents.error,
});

const mapDispatchToProps = {
  fetchDocuments,
};

export default connect(mapStateToProps, mapDispatchToProps)(Documents);
